import { useEffect, useState } from "react";

import {
  IndianRupee,
  ShoppingCart,
  TrendingUp,
  CalendarDays,
  Package,
  RefreshCw,
  Receipt,
  Wallet,
  ArrowUpRight,
  ArrowDownRight,
  Percent,
  FileText,
  MessageCircle,
  Printer,
  Copy,
  CheckCircle,
  BarChart3,
} from "lucide-react";

import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  BarChart,
  Bar,
} from "recharts";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import api from "../constant/api";
import { toast } from "react-toastify";


// ============================================================
// HELPERS
// ============================================================

const money = (value) => {
  return `₹${Number(value || 0).toLocaleString("en-IN", {
    maximumFractionDigits: 2,
  })}`;
};


const numberFormat = (value) => {
  return Number(value || 0).toLocaleString("en-IN", {
    maximumFractionDigits: 2,
  });
};


const formatDate = (date) => {
  if (!date) return "";

  const d = new Date(date);

  if (Number.isNaN(d.getTime())) {
    return date;
  }

  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};


const todayDate = () => {
  return new Date().toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
};


// ============================================================
// COMPONENT
// ============================================================

export default function SalesDashboard() {

  // ==========================================================
  // STATE
  // ==========================================================

  const [period, setPeriod] = useState("monthly");

  const [loading, setLoading] = useState(false);

  const [sharing, setSharing] = useState(false);

  const [copied, setCopied] = useState(false);

 const [data, setData] = useState({
  summary: {
    total_orders: 0,
    total_sales: 0,
    average_order_value: 0,

    today_orders: 0,
    today_sales: 0,
    today_expenses: 0,
    today_net: 0,

    month_sales: 0,
    month_expenses: 0,
    month_net: 0,

    year_sales: 0,
    year_expenses: 0,
    year_net: 0,

    expense_percentage: 0,
  },

  chart: [],
  expense_chart: [],
  top_products: [],

  today_sales_list: [],
  today_expense_list: [],
  
});



  // ==========================================================
  // LOAD DASHBOARD
  // ==========================================================

  const loadDashboard = async () => {

    try {

      setLoading(true);

     const user = JSON.parse(localStorage.getItem("user") || "{}");

const user_id = user.user_id;

const res = await api.get(
  `/Salesman/getSalesDashboard?user_id=${user_id}&period=${period}`
);

      console.log(
        "SALES DASHBOARD:",
        res.data
      );

      if (res.data?.success) {

        const apiSummary = res.data.summary || {};

setData({
  summary: {
    total_orders: Number(apiSummary.total_orders || 0),

    total_sales: Number(apiSummary.total_sales || 0),

    average_order_value:
      Number(apiSummary.average_order_value || 0),

    today_orders:
      Number(apiSummary.today_orders || 0),

    today_sales:
      Number(apiSummary.today_sales || 0),

    today_expenses:
      Number(apiSummary.today_expense || 0),

    today_net:
      Number(
        apiSummary.today_net ??
          (
            Number(apiSummary.today_sales || 0) -
            Number(apiSummary.today_expense || 0)
          )
      ),

    month_sales:
      Number(apiSummary.month_sales || 0),

    month_expenses:
      Number(apiSummary.month_expense || 0),

    month_net:
      Number(
        apiSummary.month_net ??
          (
            Number(apiSummary.month_sales || 0) -
            Number(apiSummary.month_expense || 0)
          )
      ),

    year_sales:
      Number(apiSummary.year_sales || 0),

    year_expenses:
      Number(apiSummary.year_expense || 0),

    year_net:
      Number(
        apiSummary.year_net ??
          (
            Number(apiSummary.year_sales || 0) -
            Number(apiSummary.year_expense || 0)
          )
      ),

    expense_percentage:
      Number(
        apiSummary.expense_percentage || 0
      ),
  },

  chart:
    Array.isArray(res.data.chart)
      ? res.data.chart
      : [],

  expense_chart:
    Array.isArray(res.data.expense_chart)
      ? res.data.expense_chart
      : [],

  top_products:
    Array.isArray(res.data.top_products)
      ? res.data.top_products
      : [],

  // ⭐ IMPORTANT
  today_sales_list:
    Array.isArray(res.data.today_sales_list)
      ? res.data.today_sales_list
      : [],

  // ⭐ IMPORTANT
  today_expense_list:
    Array.isArray(res.data.today_expense_list)
      ? res.data.today_expense_list
      : [],
});

      } else {

        toast.error(
          res.data?.msg ||
            "Failed to load dashboard"
        );

      }

    } catch (error) {

      console.log(
        "Dashboard Error:",
        error?.response?.data ||
          error
      );

      toast.error(
        error?.response?.data?.msg ||
          "Failed to load sales dashboard"
      );

    } finally {

      setLoading(false);

    }

  };


  useEffect(() => {

    loadDashboard();

  }, [period]);


  // ==========================================================
  // SUMMARY
  // ==========================================================

  const summary =
    data.summary || {};


  // ==========================================================
  // TODAY NET
  // ==========================================================

  const todayNet =
    Number(summary.today_sales || 0) -
    Number(summary.today_expenses || 0);


  // ==========================================================
  // MONTH NET
  // ==========================================================

  const monthNet =
    Number(summary.month_sales || 0) -
    Number(summary.month_expenses || 0);


  // ==========================================================
  // EXPENSE %
  // ==========================================================

  const expensePercentage =
    Number(summary.today_sales || 0) > 0
      ? (
          Number(
            summary.today_expenses || 0
          ) /
          Number(
            summary.today_sales || 0
          )
        ) * 100
      : 0;


  // ==========================================================
  // WHATSAPP REPORT TEXT
  // ==========================================================
const formatTime = (date) => {
  if (!date) return "";

  const d = new Date(date);

  if (Number.isNaN(d.getTime())) {
    return date;
  }

  return d.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
const generateWhatsAppReport = () => {

  const todaySales =
    Array.isArray(data.today_sales_list)
      ? data.today_sales_list
      : [];

  const todayExpenses =
    Array.isArray(data.today_expense_list)
      ? data.today_expense_list
      : [];

  const todaySalesAmount =
    Number(summary.today_sales || 0);

  const todayExpenseAmount =
    Number(summary.today_expenses || 0);

  const todayNetAmount =
    todaySalesAmount -
    todayExpenseAmount;

  // ==========================================
  // SALES LIST
  // ==========================================

  let salesList = "";

  if (todaySales.length > 0) {

    salesList = todaySales
      .map((sale, index) => {

        const orderId =
          sale.order_id ||
          sale.invoice_no ||
          sale.order_no ||
          "-";

        const customerName =
          sale.customer_name ||
          sale.name ||
          "Walk-in Customer";

        const phone =
          sale.phone ||
          "";

        const amount =
          Number(
            sale.total_amount ??
            sale.net_total ??
            sale.amount ??
            0
          );

        const date =
          sale.created_at ||
          sale.order_date ||
          sale.date ||
          "";

        return (
          `${index + 1}. *Order #${orderId}*\n` +
          `   Customer: ${customerName}\n` +
          (phone
            ? `   Phone: ${phone}\n`
            : "") +
          `   Amount: *${money(amount)}*\n` +
          (date
            ? `   Time: ${formatTime(date)}`
            : "")
        );

      })
      .join("\n\n");

  } else {

    salesList =
      "No sales found for today.";

  }

  // ==========================================
  // EXPENSE LIST
  // ==========================================

  let expenseList = "";

  if (todayExpenses.length > 0) {

    expenseList = todayExpenses
      .map((expense, index) => {

        const expenseId =
          expense.expense_id ||
          expense.id ||
          "-";

        const title =
          expense.title ||
          expense.expense_name ||
          expense.category ||
          expense.description ||
          "Expense";

        const amount =
          Number(
            expense.amount ??
            expense.total_amount ??
            0
          );

        const status =
          expense.status ||
          "approved";

        const date =
          expense.expense_date ||
          expense.created_at ||
          expense.date ||
          "";

        return (
          `${index + 1}. *${title}*\n` +
          `   Expense ID: ${expenseId}\n` +
          `   Amount: *${money(amount)}*\n` +
          `   Status: ${status}\n` +
          (date
            ? `   Time: ${formatTime(date)}`
            : "")
        );

      })
      .join("\n\n");

  } else {

    expenseList =
      "No expenses found for today.";

  }

  // ==========================================
  // REPORT
  // ==========================================

  const report = `
📊 *AK CERAMIC WORLD*

📅 *TODAY SALES & EXPENSE REPORT*

━━━━━━━━━━━━━━━━━━

💰 *TODAY SALES*

Total Sales:
*${money(todaySalesAmount)}*

Orders:
*${summary.today_orders || todaySales.length}*

━━━━━━━━━━━━━━━━━━

🧾 *TODAY SALES LIST*

${salesList}

━━━━━━━━━━━━━━━━━━

💸 *TODAY EXPENSES*

Total Expenses:
*${money(todayExpenseAmount)}*

Expense Entries:
*${todayExpenses.length}*

━━━━━━━━━━━━━━━━━━

📋 *TODAY EXPENSE LIST*

${expenseList}

━━━━━━━━━━━━━━━━━━

📈 *TODAY NET*

Sales:
${money(todaySalesAmount)}

Expenses:
- ${money(todayExpenseAmount)}

Net Amount:
*${money(todayNetAmount)}*

━━━━━━━━━━━━━━━━━━

🏁 *TODAY TOTAL*

Sales: *${money(todaySalesAmount)}*
Expense: *${money(todayExpenseAmount)}*
Net: *${money(todayNetAmount)}*

━━━━━━━━━━━━━━━━━━

Generated from
*AK Ceramic World Admin*
`;

  return report.trim();
};

  // ==========================================================
  // SEND WHATSAPP
  // ==========================================================

  const sendWhatsApp = () => {

    try {

      setSharing(true);

      const report =
        generateWhatsAppReport();

      const encoded =
        encodeURIComponent(report);

      const whatsappUrl =
        `https://wa.me/?text=${encoded}`;

      window.open(
        whatsappUrl,
        "_blank",
        "noopener,noreferrer"
      );

    } catch (error) {

      console.log(error);

      toast.error(
        "Unable to open WhatsApp"
      );

    } finally {

      setSharing(false);

    }

  };


  // ==========================================================
  // COPY REPORT
  // ==========================================================

  const copyReport = async () => {

    try {

      const report =
        generateWhatsAppReport();

      await navigator.clipboard.writeText(
        report
      );

      setCopied(true);

      toast.success(
        "Report copied"
      );

      setTimeout(() => {
        setCopied(false);
      }, 2000);

    } catch (error) {

      console.log(error);

      toast.error(
        "Unable to copy report"
      );

    }

  };


  // ==========================================================
  // PRINT
  // ==========================================================

  const printReport = () => {

    window.print();

  };


  // ==========================================================
  // PDF REPORT
  // ==========================================================

  const downloadPDF = () => {

    try {

      const doc =
        new jsPDF(
          "p",
          "mm",
          "a4"
        );


      // ------------------------------------------------------
      // HEADER
      // ------------------------------------------------------

      doc.setFontSize(20);

      doc.setFont(
        "helvetica",
        "bold"
      );

      doc.text(
        "AK Ceramic World",
        15,
        18
      );


      doc.setFontSize(14);

      doc.setFont(
        "helvetica",
        "normal"
      );

      doc.text(
        "Sales & Expense Report",
        15,
        27
      );


      doc.setFontSize(9);

      doc.text(
        `Date: ${todayDate()}`,
        15,
        34
      );


      // ------------------------------------------------------
      // TODAY SUMMARY
      // ------------------------------------------------------

      doc.setFontSize(13);

      doc.setFont(
        "helvetica",
        "bold"
      );

      doc.text(
        "Today's Summary",
        15,
        47
      );


      autoTable(
        doc,
        {
          startY: 52,

          head: [
            [
              "Particular",
              "Amount",
            ],
          ],

          body: [
            [
              "Today's Sales",
              money(
                summary.today_sales
              ),
            ],

            [
              "Today's Expenses",
              money(
                summary.today_expenses
              ),
            ],

            [
              "Today's Net",
              money(
                todayNet
              ),
            ],

            [
              "Today's Orders",
              String(
                summary.today_orders || 0
              ),
            ],

            [
              "Average Order Value",
              money(
                summary.average_order_value
              ),
            ],

            [
              "Expense Percentage",
              `${expensePercentage.toFixed(
                2
              )}%`,
            ],
          ],

          theme: "grid",

          styles: {
            fontSize: 9,
            cellPadding: 3,
          },

          headStyles: {
            fontStyle: "bold",
          },
        }
      );


      // ------------------------------------------------------
      // MONTHLY SUMMARY
      // ------------------------------------------------------

      let currentY =
        doc.lastAutoTable.finalY + 12;


      doc.setFontSize(13);

      doc.setFont(
        "helvetica",
        "bold"
      );

      doc.text(
        "Monthly Summary",
        15,
        currentY
      );


      autoTable(
        doc,
        {
          startY: currentY + 5,

          head: [
            [
              "Particular",
              "Amount",
            ],
          ],

          body: [
            [
              "Monthly Sales",
              money(
                summary.month_sales
              ),
            ],

            [
              "Monthly Expenses",
              money(
                summary.month_expenses
              ),
            ],

            [
              "Monthly Net",
              money(
                monthNet
              ),
            ],

            [
              "Yearly Sales",
              money(
                summary.year_sales
              ),
            ],

            [
              "Yearly Expenses",
              money(
                summary.year_expenses
              ),
            ],

            [
              "Yearly Net",
              money(
                summary.year_net
              ),
            ],
          ],

          theme: "grid",

          styles: {
            fontSize: 9,
            cellPadding: 3,
          },

          headStyles: {
            fontStyle: "bold",
          },
        }
      );


      // ------------------------------------------------------
      // TOP PRODUCTS
      // ------------------------------------------------------

      currentY =
        doc.lastAutoTable.finalY + 12;


      doc.setFontSize(13);

      doc.setFont(
        "helvetica",
        "bold"
      );

      doc.text(
        "Top Selling Products",
        15,
        currentY
      );


      const productRows =
        data.top_products
          .slice(0, 10)
          .map(
            (product, index) => [
              index + 1,

              product.product_name ||
                `Product #${product.product_id}`,

              numberFormat(
                product.quantity || 0
              ),

              money(
                product.sales || 0
              ),
            ]
          );


      autoTable(
        doc,
        {
          startY: currentY + 5,

          head: [
            [
              "#",
              "Product",
              "Qty",
              "Sales",
            ],
          ],

          body:
            productRows.length
              ? productRows
              : [
                  [
                    "-",
                    "No product sales",
                    "-",
                    "-",
                  ],
                ],

          theme: "striped",

          styles: {
            fontSize: 8,
            cellPadding: 3,
          },

          headStyles: {
            fontStyle: "bold",
          },
        }
      );


      // ------------------------------------------------------
      // FOOTER
      // ------------------------------------------------------

      const pageCount =
        doc.internal.getNumberOfPages();


      for (
        let i = 1;
        i <= pageCount;
        i++
      ) {

        doc.setPage(i);

        doc.setFontSize(8);

        doc.setFont(
          "helvetica",
          "normal"
        );

        doc.text(
          `AK Ceramic World | Sales Report | Page ${i} of ${pageCount}`,
          15,
          290
        );

      }


      // ------------------------------------------------------
      // SAVE
      // ------------------------------------------------------

      const fileDate =
        new Date()
          .toISOString()
          .split("T")[0];


      doc.save(
        `AK-Ceramic-World-Sales-Report-${fileDate}.pdf`
      );


      toast.success(
        "PDF report downloaded"
      );

    } catch (error) {

      console.log(
        "PDF Error:",
        error
      );

      toast.error(
        "Failed to create PDF"
      );

    }

  };


  // ==========================================================
  // FORMAT DATE
  // ==========================================================

  const chartDate =
    (date) => {

      if (!date) return "";

      const d =
        new Date(date);

      if (
        Number.isNaN(
          d.getTime()
        )
      ) {
        return date;
      }

      return d.toLocaleDateString(
        "en-IN",
        {
          day: "2-digit",
          month: "short",
        }
      );

    };


  // ==========================================================
  // LOADING
  // ==========================================================

  if (loading && !data.chart.length) {

    return (

      <div className="
        min-h-screen
        bg-gray-50
        p-4
        md:p-6
      ">

        <div className="
          animate-pulse
        ">

          <div className="
            h-8
            w-64
            bg-gray-200
            rounded
            mb-3
          " />

          <div className="
            h-4
            w-80
            bg-gray-200
            rounded
            mb-6
          " />

          <div className="
            grid
            grid-cols-2
            lg:grid-cols-4
            gap-4
          ">

            {Array.from({
              length: 8,
            }).map(
              (_, index) => (

                <div
                  key={index}
                  className="
                    h-32
                    bg-gray-200
                    rounded-2xl
                  "
                />

              )
            )}

          </div>

        </div>

      </div>

    );

  }


  // ==========================================================
  // UI
  // ==========================================================

  return (

    <div
      id="sales-dashboard"
      className="
        min-h-screen
        bg-gray-50
        p-3
        md:p-6
        space-y-5
      "
    >

      {/* ====================================================
          HEADER
      ==================================================== */}

      <div className="
        flex
        flex-col
        xl:flex-row
        xl:items-center
        xl:justify-between
        gap-4
      ">

        <div>

          <h1 className="
            text-2xl
            md:text-3xl
            font-black
            text-gray-900
          ">

            Sales Dashboard

          </h1>

          <p className="
            text-sm
            text-gray-500
            mt-1
          ">

            Sales, expenses and daily performance

          </p>

        </div>


        {/* ACTIONS */}

        <div className="
          flex
          flex-wrap
          gap-2
        ">

          {/* WHATSAPP */}

         <button
  onClick={sendWhatsApp}
  disabled={sharing}
  className="
    flex
    items-center
    gap-2
    bg-green-600
    hover:bg-green-700
    text-white
    px-4
    py-2.5
    rounded-xl
    text-sm
    font-semibold
    shadow-sm
    disabled:opacity-50
  "
>
  <MessageCircle size={17} />

  {sharing ? "Opening..." : "WhatsApp"}
</button>

          {/* PDF */}

          <button
            onClick={downloadPDF}
            className="
              flex
              items-center
              gap-2
              bg-red-600
              hover:bg-red-700
              text-white
              px-4
              py-2.5
              rounded-xl
              text-sm
              font-semibold
              shadow-sm
            "
          >

            <FileText
              size={17}
            />

            PDF

          </button>


          {/* COPY */}

          <button
            onClick={copyReport}
            className="
              flex
              items-center
              gap-2
              bg-white
              border
              border-gray-200
              hover:bg-gray-100
              text-gray-700
              px-4
              py-2.5
              rounded-xl
              text-sm
              font-semibold
            "
          >

            {copied ? (
              <CheckCircle
                size={17}
              />
            ) : (
              <Copy
                size={17}
              />
            )}

            {copied
              ? "Copied"
              : "Copy"}

          </button>


          {/* PRINT */}

          <button
            onClick={printReport}
            className="
              flex
              items-center
              gap-2
              bg-white
              border
              border-gray-200
              hover:bg-gray-100
              text-gray-700
              px-4
              py-2.5
              rounded-xl
              text-sm
              font-semibold
            "
          >

            <Printer
              size={17}
            />

            Print

          </button>


          {/* REFRESH */}

          <button
            onClick={loadDashboard}
            disabled={loading}
            className="
              bg-white
              border
              border-gray-200
              p-2.5
              rounded-xl
              hover:bg-gray-100
            "
          >

            <RefreshCw
              size={18}
              className={
                loading
                  ? "animate-spin"
                  : ""
              }
            />

          </button>


          {/* PERIOD */}

          <select
            value={period}
            onChange={(e) =>
              setPeriod(
                e.target.value
              )
            }
            className="
              bg-white
              border
              border-gray-200
              rounded-xl
              px-4
              py-2.5
              text-sm
              font-semibold
              outline-none
            "
          >

            <option value="daily">
              Daily
            </option>

            <option value="monthly">
              Monthly
            </option>

            <option value="yearly">
              Yearly
            </option>

          </select>

        </div>

      </div>


      {/* ====================================================
          TODAY MAIN SUMMARY
      ==================================================== */}

      <div className="
        bg-gradient-to-br
        from-gray-950
        via-gray-900
        to-gray-800
        rounded-3xl
        p-5
        md:p-7
        text-white
        shadow-xl
      ">

        <div className="
          grid
          grid-cols-1
          md:grid-cols-3
          gap-6
        ">

          {/* SALES */}

          <div>

            <div className="
              flex
              items-center
              gap-2
              text-gray-400
              text-sm
            ">

              <ArrowUpRight
                size={17}
              />

              Today's Sales

            </div>

            <h2 className="
              text-3xl
              md:text-4xl
              font-black
              mt-2
            ">

              {money(
                summary.today_sales
              )}

            </h2>

            <p className="
              text-gray-400
              text-xs
              mt-1
            ">

              {summary.today_orders || 0}
              {" "}
              orders

            </p>

          </div>


          {/* EXPENSE */}

          <div>

            <div className="
              flex
              items-center
              gap-2
              text-gray-400
              text-sm
            ">

              <ArrowDownRight
                size={17}
              />

              Today's Expenses

            </div>

            <h2 className="
              text-3xl
              md:text-4xl
              font-black
              mt-2
              text-red-400
            ">

              {money(
                summary.today_expenses
              )}

            </h2>

            <p className="
              text-gray-400
              text-xs
              mt-1
            ">

              {expensePercentage.toFixed(
                2
              )}% of sales

            </p>

          </div>


          {/* NET */}

          <div>

            <div className="
              flex
              items-center
              gap-2
              text-gray-400
              text-sm
            ">

              <Wallet
                size={17}
              />

              Today's Net

            </div>

            <h2 className={`
              text-3xl
              md:text-4xl
              font-black
              mt-2
              ${
                todayNet >= 0
                  ? "text-green-400"
                  : "text-red-400"
              }
            `}>

              {money(todayNet)}

            </h2>

            <p className="
              text-gray-400
              text-xs
              mt-1
            ">

              Sales − Expenses

            </p>

          </div>

        </div>

      </div>


      {/* ====================================================
          TODAY CARDS
      ==================================================== */}

      <div className="
        grid
        grid-cols-2
        lg:grid-cols-4
        gap-3
        md:gap-5
      ">

        {/* TODAY SALES */}

        <div className="
          bg-white
          rounded-2xl
          p-4
          md:p-5
          shadow-sm
          border
          border-gray-100
        ">

          <div className="
            flex
            justify-between
            items-start
          ">

            <div>

              <p className="
                text-xs
                text-gray-500
              ">

                Today's Sales

              </p>

              <h3 className="
                text-xl
                md:text-2xl
                font-black
                mt-1
              ">

                {money(
                  summary.today_sales
                )}

              </h3>

            </div>

            <div className="
              bg-green-100
              text-green-600
              p-2.5
              rounded-xl
            ">

              <IndianRupee
                size={20}
              />

            </div>

          </div>

        </div>


        {/* EXPENSE */}

        <div className="
          bg-white
          rounded-2xl
          p-4
          md:p-5
          shadow-sm
          border
          border-gray-100
        ">

          <div className="
            flex
            justify-between
            items-start
          ">

            <div>

              <p className="
                text-xs
                text-gray-500
              ">

                Today's Expense

              </p>

              <h3 className="
                text-xl
                md:text-2xl
                font-black
                mt-1
                text-red-600
              ">

                {money(
                  summary.today_expenses
                )}

              </h3>

            </div>

            <div className="
              bg-red-100
              text-red-600
              p-2.5
              rounded-xl
            ">

              <Receipt
                size={20}
              />

            </div>

          </div>

        </div>


        {/* NET */}

        <div className="
          bg-white
          rounded-2xl
          p-4
          md:p-5
          shadow-sm
          border
          border-gray-100
        ">

          <div className="
            flex
            justify-between
            items-start
          ">

            <div>

              <p className="
                text-xs
                text-gray-500
              ">

                Today's Net

              </p>

              <h3 className={`
                text-xl
                md:text-2xl
                font-black
                mt-1
                ${
                  todayNet >= 0
                    ? "text-green-600"
                    : "text-red-600"
                }
              `}>

                {money(todayNet)}

              </h3>

            </div>

            <div className="
              bg-blue-100
              text-blue-600
              p-2.5
              rounded-xl
            ">

              <Wallet
                size={20}
              />

            </div>

          </div>

        </div>


        {/* EXPENSE % */}

        <div className="
          bg-white
          rounded-2xl
          p-4
          md:p-5
          shadow-sm
          border
          border-gray-100
        ">

          <div className="
            flex
            justify-between
            items-start
          ">

            <div>

              <p className="
                text-xs
                text-gray-500
              ">

                Expense Ratio

              </p>

              <h3 className="
                text-xl
                md:text-2xl
                font-black
                mt-1
              ">

                {expensePercentage.toFixed(
                  2
                )}%

              </h3>

            </div>

            <div className="
              bg-orange-100
              text-orange-600
              p-2.5
              rounded-xl
            ">

              <Percent
                size={20}
              />

            </div>

          </div>

        </div>

      </div>


      {/* ====================================================
          MONTHLY SUMMARY
      ==================================================== */}

      <div className="
        bg-white
        rounded-2xl
        p-5
        md:p-6
        border
        border-gray-100
        shadow-sm
      ">

        <div className="
          flex
          items-center
          gap-2
          mb-5
        ">

          <CalendarDays
            size={20}
            className="text-blue-600"
          />

          <div>

            <h2 className="
              text-lg
              font-bold
              text-gray-800
            ">

              Monthly Performance

            </h2>

            <p className="
              text-xs
              text-gray-400
            ">

              Current month calculation

            </p>

          </div>

        </div>


        <div className="
          grid
          grid-cols-1
          md:grid-cols-3
          gap-4
        ">

          <div className="
            bg-green-50
            rounded-2xl
            p-5
          ">

            <p className="
              text-xs
              text-green-600
              font-semibold
            ">

              Monthly Sales

            </p>

            <p className="
              text-2xl
              font-black
              text-green-700
              mt-1
            ">

              {money(
                summary.month_sales
              )}

            </p>

          </div>


          <div className="
            bg-red-50
            rounded-2xl
            p-5
          ">

            <p className="
              text-xs
              text-red-600
              font-semibold
            ">

              Monthly Expenses

            </p>

            <p className="
              text-2xl
              font-black
              text-red-700
              mt-1
            ">

              {money(
                summary.month_expenses
              )}

            </p>

          </div>


          <div className="
            bg-blue-50
            rounded-2xl
            p-5
          ">

            <p className="
              text-xs
              text-blue-600
              font-semibold
            ">

              Monthly Net

            </p>

            <p className="
              text-2xl
              font-black
              text-blue-700
              mt-1
            ">

              {money(monthNet)}

            </p>

          </div>

        </div>

      </div>


      {/* ====================================================
          SALES CHART
      ==================================================== */}

      <div className="
        bg-white
        rounded-2xl
        p-4
        md:p-6
        shadow-sm
        border
        border-gray-100
      ">

        <div className="
          flex
          items-center
          justify-between
          mb-5
        ">

          <div>

            <div className="
              flex
              items-center
              gap-2
            ">

              <BarChart3
                size={20}
                className="text-blue-600"
              />

              <h2 className="
                text-lg
                font-bold
                text-gray-800
              ">

                Sales Performance

              </h2>

            </div>

            <p className="
              text-xs
              text-gray-400
              mt-1
            ">

              Sales by date

            </p>

          </div>

        </div>


        <div className="
          w-full
          h-[280px]
          md:h-[360px]
        ">

          {data.chart.length === 0 ? (

            <div className="
              h-full
              flex
              items-center
              justify-center
              text-gray-400
            ">

              No sales data available

            </div>

          ) : (

            <ResponsiveContainer
              width="100%"
              height="100%"
            >

              <AreaChart
                data={data.chart}
              >

                <defs>

                  <linearGradient
                    id="salesGradient"
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="1"
                  >

                    <stop
                      offset="5%"
                      stopOpacity={0.35}
                    />

                    <stop
                      offset="95%"
                      stopOpacity={0}
                    />

                  </linearGradient>

                </defs>


                <CartesianGrid
                  strokeDasharray="3 3"
                />


                <XAxis
                  dataKey="sale_date"
                  tickFormatter={
                    chartDate
                  }
                />


                <YAxis />


                <Tooltip
                  formatter={(value) =>
                    money(value)
                  }
                  labelFormatter={
                    chartDate
                  }
                />


                <Area
                  type="monotone"
                  dataKey="sales"
                  strokeWidth={3}
                  fill="url(#salesGradient)"
                />

              </AreaChart>

            </ResponsiveContainer>

          )}

        </div>

      </div>


      {/* ====================================================
          EXPENSE CHART
      ==================================================== */}

      {data.expense_chart.length > 0 && (

        <div className="
          bg-white
          rounded-2xl
          p-4
          md:p-6
          shadow-sm
          border
          border-gray-100
        ">

          <div className="
            flex
            items-center
            gap-2
            mb-5
          ">

            <Receipt
              size={20}
              className="text-red-600"
            />

            <div>

              <h2 className="
                text-lg
                font-bold
                text-gray-800
              ">

                Expense Performance

              </h2>

              <p className="
                text-xs
                text-gray-400
              ">

                Expense by date

              </p>

            </div>

          </div>


          <div className="
            h-[280px]
            md:h-[350px]
          ">

            <ResponsiveContainer
              width="100%"
              height="100%"
            >

              <BarChart
                data={
                  data.expense_chart
                }
              >

                <CartesianGrid
                  strokeDasharray="3 3"
                />

                <XAxis
                  dataKey="expense_date"
                  tickFormatter={
                    chartDate
                  }
                />

                <YAxis />

                <Tooltip
                  formatter={(value) =>
                    money(value)
                  }
                  labelFormatter={
                    chartDate
                  }
                />

                <Bar
                  dataKey="expenses"
                  radius={[
                    8,
                    8,
                    0,
                    0,
                  ]}
                />

              </BarChart>

            </ResponsiveContainer>

          </div>

        </div>

      )}


      {/* ====================================================
          TOP PRODUCTS
      ==================================================== */}

      <div className="
        bg-white
        rounded-2xl
        shadow-sm
        border
        border-gray-100
        overflow-hidden
      ">

        <div className="
          p-5
          border-b
          border-gray-100
        ">

          <div className="
            flex
            items-center
            gap-2
          ">

            <Package
              size={20}
              className="text-purple-600"
            />

            <h2 className="
              text-lg
              font-bold
              text-gray-800
            ">

              Top Selling Products

            </h2>

          </div>

          <p className="
            text-xs
            text-gray-400
            mt-1
          ">

            Best performing products

          </p>

        </div>


        <div className="
          divide-y
          divide-gray-100
        ">

          {data.top_products.length ===
          0 ? (

            <div className="
              text-center
              py-10
              text-gray-400
            ">

              No product sales found.

            </div>

          ) : (

            data.top_products.map(
              (product, index) => (

                <div
                  key={`${product.product_id}-${index}`}
                  className="
                    flex
                    items-center
                    justify-between
                    gap-3
                    p-4
                    hover:bg-gray-50
                  "
                >

                  <div className="
                    flex
                    items-center
                    gap-3
                    min-w-0
                  ">

                    <div className="
                      w-9
                      h-9
                      rounded-xl
                      bg-gray-100
                      flex
                      items-center
                      justify-center
                      font-bold
                      text-gray-600
                      shrink-0
                    ">

                      {index + 1}

                    </div>


                    <div className="
                      min-w-0
                    ">

                      <p className="
                        font-semibold
                        text-gray-800
                        truncate
                      ">

                        {product.product_name ||
                          `Product #${product.product_id}`}

                      </p>

                      <p className="
                        text-xs
                        text-gray-400
                      ">

                        Qty:{" "}
                        {numberFormat(
                          product.quantity || 0
                        )}

                      </p>

                    </div>

                  </div>


                  <p className="
                    font-bold
                    text-blue-600
                    shrink-0
                  ">

                    {money(
                      product.sales
                    )}

                  </p>

                </div>

              )
            )

          )}

        </div>

      </div>


      {/* ====================================================
          REPORT PREVIEW
      ==================================================== */}

      <div className="
        bg-white
        rounded-2xl
        border
        border-gray-100
        p-5
        print:hidden
      ">

        <div className="
          flex
          items-center
          justify-between
          mb-4
        ">

          <div>

            <h2 className="
              font-bold
              text-gray-800
            ">

              Quick Report

            </h2>

            <p className="
              text-xs
              text-gray-400
            ">

              Ready to send to management

            </p>

          </div>

          <CheckCircle
            size={20}
            className="text-green-600"
          />

        </div>


        <pre className="
          whitespace-pre-wrap
          bg-gray-50
          rounded-xl
          p-4
          text-xs
          text-gray-600
          overflow-x-auto
          border
        ">

          {generateWhatsAppReport()}

        </pre>

      </div>

    </div>

  );

}